export enum FileUploadStatusEnum {
    Waiting = 'waiting',
    Uploading = 'uploading',
    Downloading = 'downloading',
    Error = 'error',
    Done = 'done'
}
